import { call, put, takeLatest } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

// `uuid` must be the brand's encrypted uuid for the creator (custom / chat routes: `uuid`,
// public route: `private_uuid`, only available once the creator is unmasked).
function* getCreatorMonthlySales({ payload: { uuid, signal } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.analytics.users,
      data: {
        user_uuids: [uuid],
        since: 'now-12M/M',
        until: 'now/d',
        page: 1
      },
      signal
    });

    yield put(actions.getCreatorMonthlySalesDone(data.histogram || []));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getCreatorMonthlySalesFailed,
      suppressCriticalErrors: [404],
      endpoint: api.analytics.users.url
    });
  }
}

export const getCreatorMonthlySalesSaga = takeLatest(types.GET_CREATOR_MONTHLY_SALES_REQUEST, getCreatorMonthlySales);
